import reduceReducers from 'reduce-reducers';
import { combineReducers, Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import {
  ActionWithPlayload,
  EntityAction,
  ErrorAction,
} from '../../../store/types';

export interface ExperimentCollectionState {
  items: string[];
  total: number | undefined;
  isFetching: boolean;
  error?: string | null;
}

export interface ExperimentsViewState {
  all: ExperimentCollectionState;
  requested: ExperimentCollectionState;
  scheduled: ExperimentCollectionState;
  started: ExperimentCollectionState;
  completed: ExperimentCollectionState;
  aborted: ExperimentCollectionState;
}

export interface ExperimentsState {
  view: ExperimentsViewState;
}

export const initialState: ExperimentCollectionState = {
  items: [],
  total: 0,
  isFetching: false,
  error: null,
};

type Action =
  | ActionWithPlayload<ActionType.FETCH_EXPERIMENTS_STARTED>
  | EntityAction<ActionType.FETCH_EXPERIMENTS_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_EXPERIMENTS_FAILED>
  | EntityAction<ActionType.CREATE_EXPERIMENT_SUCCEEDED>;

export const createExperimentListReducer = (
  experimentState: string,
): Reducer<ExperimentCollectionState, Action> => {
  const experimentCollectionReducer: Reducer<
    ExperimentCollectionState,
    Action
  > = (state = initialState, action) => {
    if (
      action.payload &&
      action.payload.experimentStates &&
      action.payload.experimentStates.indexOf(experimentState) > -1
    ) {
      switch (action.type) {
        case ActionType.FETCH_EXPERIMENTS_STARTED:
          return {
            ...state,
            isFetching: true,
          };

        case ActionType.FETCH_EXPERIMENTS_SUCCEEDED:
          return {
            ...state,
            isFetching: false,
            total: action.payload.total,
            items: action.payload.result as string[],
          };

        case ActionType.FETCH_EXPERIMENTS_FAILED:
          return {
            ...state,
            isFetching: false,
            error: action.payload.message,
          };
        default:
          return state;
      }
    }

    return state;
  };

  return experimentCollectionReducer;
};

export const requestedExperimentsReducer: Reducer<
  ExperimentCollectionState,
  Action
> = (state, action) => {
  switch (action.type) {
    case ActionType.CREATE_EXPERIMENT_SUCCEEDED:
      return {
        ...state!,
        items: [...state!.items, action.payload.result as string],
      };
    default:
      return state!;
  }
};

export const experimentsViewReducer: Reducer<ExperimentsViewState> =
  combineReducers<ExperimentsViewState>({
    all: createExperimentListReducer(''),
    requested: reduceReducers(
      createExperimentListReducer('REQUESTED'),
      requestedExperimentsReducer,
    ),
    scheduled: createExperimentListReducer('SCHEDULED'),
    started: createExperimentListReducer('STARTED'),
    completed: createExperimentListReducer('COMPLETED'),
    aborted: createExperimentListReducer('ABORTED'),
  });

const experimentsReducer: Reducer<ExperimentsState> =
  combineReducers<ExperimentsState>({
    view: experimentsViewReducer,
  });

export default experimentsReducer;
